import { Watermark } from '@src/modules/players/shared/interfaces/player-configs.interface';
import watermark from '@root/private/js/common/watermark';

export const printWatermark = (label: string, option?: Watermark) => {
  jwplayer().on('ready', () => {
    watermark(jwplayer().getContainer() as HTMLDivElement, label, {
      ...option,
    });
  });
};
